import { apiInstance } from '../api';

const route = '/apartment/admin';

// repeated keys for lists (?rooms=a&rooms=b), as the portal's search reads them
const serialize = (params) => {
  const search = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    ;(Array.isArray(value) ? value : [value]).forEach((v) => search.append(key, v))
  })
  return search.toString()
}

// the admin panel's flat editor (express controllers/apartment/editor.js)
export class ApartmentsService {
  // q (ids, flat number, complex or address), complexId, status, source (eci_old | manual), sort (id | updated | price), page, limit,
  // and any filter of the portal's search (backend service/search/filters.js)
  static async fetchList(params) {
    return apiInstance.get(`${route}/list`, { params, paramsSerializer: serialize })
  }

  // the portal's search filters this user may use
  static async fetchFilterConfig() {
    return apiInstance.get('/search/config')
  }

  // their options: what the flats have, over every status and with hidden flats
  static async fetchFilterOptions() {
    return apiInstance.get('/search/facets', { params: { includeUnavailable: 1, hidden: 'with' } })
  }

  // the form: sections with fields this user sees ({ key, title, kind, options }), editable fields, placement right
  static async fetchMeta() {
    return apiInstance.get(`${route}/meta`)
  }

  static async fetchBuildings(complexId) {
    return apiInstance.get(`${route}/buildings`, { params: { complexId } })
  }

  // what a new flat in this complex (and building) starts with: address, coordinates, district, metro, deadline…
  static async fetchDefaults(complexId, buildingId) {
    return apiInstance.get(`${route}/defaults`, { params: { complexId, buildingId } })
  }

  // { apartment, placement, eciOldId, editable, canPlace }
  static async fetchApartment(id) {
    return apiInstance.get(`${route}/${id}`)
  }

  // only the changed fields, and placement: { residentialComplexId, buildingId, section } when it changed
  static async updateApartment(id, changes) {
    return apiInstance.put(`${route}/${id}`, changes)
  }

  // «Наши», «Залог», «Вознаграждение» and its sum, «Цена», «Рыночная цена» as the save will work them out from the
  // form's changed fields (apartmentId: none for a new flat; complexId: its ЖК, for the ЖК's priority); nothing is written
  static async previewPrices(apartmentId, complexId, changes) {
    return apiInstance.post(`${route}/prices`, { apartmentId, complexId, changes })
  }

  // «Аналоги в ЖК» and «Аналоги поблизости» of one flat, as the portal shows them under a single flat found:
  // { inComplex: [...], nearby: [...] } (backend service/search/search.service.js analogs)
  static async fetchAnalogs(apartmentId) {
    return apiInstance.get(`/search/analogs/${apartmentId}`)
  }

  // «Массовая правка»: one value of a field for many flats
  static async bulkUpdate(ids, changes) {
    return apiInstance.put(`${route}/bulk`, { ids, changes })
  }

  // «В Запас» (stock true) / «Из Запаса» (false) for the flats chosen: { updated, refused }
  static async setStock(ids, stock) {
    return apiInstance.put(`${route}/stock`, { ids, stock })
  }

  // every flat the list's filters find: { ids, eciOld, more }
  static async fetchIds(params) {
    return apiInstance.get(`${route}/list`, { params: { ...params, idsOnly: 1 }, paramsSerializer: serialize })
  }

  static async createApartment(values) {
    return apiInstance.post(route, values)
  }

  static async uploadPhoto(id, field, file) {
    const formData = new FormData()
    formData.append('file', file)
    return apiInstance.post(`${route}/${id}/file/${field}`, formData)
  }

  static async deleteApartment(id) {
    return apiInstance.delete(`${route}/${id}`)
  }

  // value lists of the form
  static async fetchComplexNames() {
    return apiInstance.get('/residentialComplex/names')
  }

  static async fetchSelections() {
    return apiInstance.get('/groupSelection')
  }
}
